<div *ngIf="loading$ | async" class="loader-container">
    <div class="loader"></div>
  </div>
  